export default {
  ContactUs: "ContactUs",
};
